<template>
  <div>
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" label-width="100px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item label-width="50px" :label="$t('SystemMaintenance.Branch')">
              <el-select v-model="branchId" no="1" @change="getConfig(branchId)">
                <el-option
                  v-for="office in currentOfficeList"
                  :key="office.officeId"
                  :value="office.officeId"
                  :label="office.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="branchId!==1" :label="$t('SystemMaintenance.ApplyTheHeadOfficesSettings')">
              <el-checkbox v-model="ifApplied" no="2" @change="applyHeadOfficeConfig" />
            </el-form-item>
          </div>
        </el-form>
        <br>
        <el-button type="primary" no="3" style="margin-left: 5px;" @click="saveConfig()">
          {{ $t('common.btn.save') }}
        </el-button>
      </div>
      <div class="triggers" />
    </div>
    <div id="financial-archiving-settings" ref="container" class="show-right" style="height: 90%">
      <div class="main-content left" style="height: 97%">
        <div style="margin-top: 50px;margin-left: 30px">
          <span style="font-size: 18px">{{ $t('CargoMsg.Financial_Filing_Preconditions') }}:</span>
          <div style="width: 400px">
            <el-form :inline="false" label-width="220px" label-position="right" style="margin-top: 20px">
              <el-form-item :label="$t('CargoMsg.WHETHER_FINANCIAL_AUDIT')">
                <el-select v-model="archivingConfig.financialAlertType" no="4" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in alertTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.WHETHER_ACCRUED')">
                <el-select v-model="archivingConfig.accruedAlertType" no="5" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in alertTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.FINANCIAL_RECEIVABLES_VERIFICATION')">
                <el-select v-model="archivingConfig.receivablesVerificationAlertType" no="6" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in alertTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.FINANCIAL_DUE_VERIFICATION')">
                <el-select v-model="archivingConfig.dueVerificationAlertType" no="7" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in alertTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.FINANCIAL_CHARGE')">
                <el-select v-model="archivingConfig.chargeAlertType" no="8" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in alertTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="division" style="height: 97%">
        &nbsp;
      </div>
      <div class="right" style="height: 97%">
        <div style="margin-top: 50px;margin-left: 30px">
          <span style="font-size: 18px">{{ $t('CargoMsg.Financial_Filing_Effective_Effect') }}:</span>
          <div style="width: 300px">
            <el-form :inline="false" label-width="150px" label-position="right" style="margin-top: 20px">
              <el-form-item :label="$t('CargoMsg.CANCEL_FINANCIAL_AUDIT')">
                <el-select v-model="effectConfig.cancelFinancialAudit" no="9" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.MODIFY_CHARGE')">
                <el-select v-model="effectConfig.modifyCharge" no="10" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.MODIFY_JOB')">
                <el-select v-model="effectConfig.modifyJob" no="11" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.MODIFY_RATE')">
                <el-select v-model="effectConfig.modifyRate" no="12" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.MODIFY_FINANCE_JOB_DATE')">
                <el-select v-model="effectConfig.modifyFinanceJobDate" no="13" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-show="false" :label="$t('CargoMsg.GENERATE_RED_INVOICE')">
                <el-select v-model="effectConfig.generateRedInvoice" no="14" style="width:150px;" :disabled="true">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-show="false" :label="$t('CargoMsg.RECEIVABLE_GENERATES_INVOICE')">
                <el-select v-model="effectConfig.receivableGeneratesInvoice" no="15" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-show="false" :label="$t('CargoMsg.COPE_GENERATES_INVOICE')">
                <el-select v-model="effectConfig.copeGeneratesInvoice" no="16" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-show="false" :label="$t('CargoMsg.CANCEL_RECEIVABLE_VERIFICATION')">
                <el-select v-model="effectConfig.cancelReceivableVerification" no="17" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-show="false" :label="$t('CargoMsg.COPE_RECEIVABLE_VERIFICATION')">
                <el-select v-model="effectConfig.copeReceivableVerification" no="18" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.MODIFY_ACCRUAL')">
                <el-select v-model="effectConfig.modifyAccrual" no="19" style="width:150px;" :disabled="ifApplied">
                  <el-option
                    v-for="(item) in prohibitedTypes"
                    :key="item.code"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getConfig, saveConfig } from '@/api/sysManage/baseConfig/financialArchivingSetting'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'FinancialArchivingSettings',
  data() {
    return {
      branchId: null,
      ifApplied: false,
      archivingConfig: {
        officeId: 0,
        financialAlertType: 2,
        accruedAlertType: 1,
        receivablesVerificationAlertType: 1,
        dueVerificationAlertType: 1,
        chargeAlertType: 2
      },
      effectConfig: {
        officeId: 0,
        cancelFinancialAudit: 1,
        modifyCharge: 1,
        modifyJob: 1,
        modifyRate: 1,
        modifyFinanceJobDate: 1,
        generateRedInvoice: 1,
        receivableGeneratesInvoice: 1,
        copeGeneratesInvoice: 1,
        cancelReceivableVerification: 0,
        copeReceivableVerification: 0,
        modifyAccrual: 0
      },
      alertTypes: SystemConstants.ALERT_TYPE,
      prohibitedTypes: SystemConstants.PROHIBITED_TYPE
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  watch: {

  },
  mounted() {
    this.branchId = this.currentOfficeList[0].officeId
    this.getConfig(this.branchId)
  },
  beforeDestroy() {
  },
  methods: {
    async getConfig(value) {
      const self = this
      self.loading = getLoading()
      await getConfig(value).then(res => {
        if (res && res.data) {
          if (res.data.archivingConfig) {
            self.archivingConfig = res.data.archivingConfig
            self.ifApplied = res.data.archivingConfig.ifApplied === 1
          }
          if (res.data.effectConfig) {
            self.effectConfig = res.data.effectConfig
          }
        }
      }).finally(
        self.loading.close()
      )
    },
    saveConfig() {
      const self = this
      self.loading = getLoading()
      this.archivingConfig.officeId = this.branchId
      this.archivingConfig.ifApplied = this.ifApplied
      this.effectConfig.officeId = this.branchId
      this.effectConfig.ifApplied = this.ifApplied
      saveConfig({ archivingConfig: this.archivingConfig, effectConfig: this.effectConfig }).then(res => {
        if (res.ok) {
          self.$message.success(self.$t('common.tips.saveSuccess'))
          self.getPushConfig(self.branchId)
        } else {
          self.$message.success(self.$t('CargoMsg.Cargo_SaveFailed'))
        }
      }).finally(
        self.loading.close()
      )
    },
    async applyHeadOfficeConfig(value) {
      if (value) {
        await this.getConfig(1)
      } else {
        await this.getConfig(this.branchId)
      }
      this.ifApplied = value
    }
  }
}
</script>

<style scoped lang="scss">
#financial-archiving-settings.show-right {
  background-color: #FFFFFF;
  display: block;
  float: left;
  width: 100%;
  min-width: 1000px;
  overflow-x: auto;
  margin-top: 5px;
  .left {
    min-width: 450px;
    display: block;
    float: left;
    width: calc(30% - 6px);
  }
  .division {
    background-color: #2d2f33;
    display: table;
    float: left;
    width: 1px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .right {
    display: block;
    float: left;
    width: calc(30% - 6px);
    min-width: 450px;
  }
}
</style>
